export default __webpack_public_path__ + "static/media/mockup.aa584a46.png";